import { render, staticRenderFns } from "./TheLoader.vue?vue&type=template&id=5ff25c97&scoped=true"
var script = {}
import style0 from "./TheLoader.vue?vue&type=style&index=0&id=5ff25c97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff25c97",
  null
  
)

export default component.exports